/** Stream filter for Manage Products / Teams / Tenants when multiple AI streams exist. */
export type ManageEntityStreamFilter = 'all' | string;

export function streamLabelForId(
  streamOptions: Array<{ streamId: string; displayName: string }>,
  streamId: string,
): string {
  const o = streamOptions.find((s) => s.streamId === streamId);
  return o?.displayName?.trim() || streamId;
}

/**
 * Pill / tag row: All + one control per stream. Single-stream setups render nothing (filter is implicit).
 */
export function ManageEntityStreamFilterPills({
  streamOptions,
  activeFilter,
  onActiveFilterChange,
}: {
  streamOptions: Array<{ streamId: string; displayName: string }>;
  activeFilter: ManageEntityStreamFilter;
  onActiveFilterChange: (filter: ManageEntityStreamFilter) => void;
}) {
  if (streamOptions.length <= 1) return null;

  const pillClass = (on: boolean) =>
    `rounded-full px-3 py-1 text-xs font-medium transition-colors border ${
      on
        ? 'border-blue-500 bg-blue-50 text-blue-800 dark:border-blue-400 dark:bg-blue-950/50 dark:text-blue-200'
        : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700/40'
    }`;

  return (
    <div className="mb-4 flex flex-col gap-2">
      <span className="text-xs font-medium text-gray-500 dark:text-gray-400">Streams</span>
      <div className="flex flex-wrap gap-1.5">
        <button
          type="button"
          className={pillClass(activeFilter === 'all')}
          onClick={() => onActiveFilterChange('all')}
        >
          All
        </button>
        {streamOptions.map((s) => {
          const on = activeFilter === s.streamId;
          return (
            <button
              key={s.streamId}
              type="button"
              className={pillClass(on)}
              onClick={() => onActiveFilterChange(s.streamId)}
            >
              {s.displayName?.trim() || s.streamId}
            </button>
          );
        })}
      </div>
    </div>
  );
}
